import React from 'react';

const CustomButton = ({
  textLoad,
  loading,
  onClick,
  className = '',
  children,
  isDisabled,
  ...props
}) => {
  const baseButtonStyles =
    'flex justify-center items-center rounded-[5px] border-b border-solid border-black border-opacity-50 text-white transition-all duration-200';

  const responsivePadding = 'px-4 py-1 sm:px-6 sm:py-2'; // Responsive padding
  const responsiveText = 'text-sm sm:text-base'; // Text size responsive
  const spacing = 'mr-2 mb-2 sm:mr-3'; // Margin responsive

  const activeButtonClassName = `bg-o2o-gray-button hover:bg-mts-blue-hover ${
    isDisabled ? 'opacity-50 cursor-not-allowed' : ''
  }`;

  const finalClassName = `${baseButtonStyles} ${responsivePadding} ${responsiveText} ${spacing} ${activeButtonClassName} ${className}`;

  const loadingClassName = `${baseButtonStyles} ${responsivePadding} ${responsiveText} ${spacing} bg-gray-400 cursor-not-allowed`;

  return (
    <>
      {loading ? (
        <button onClick={onClick} className={loadingClassName} disabled {...props}>
          <svg
            className="animate-spin h-5 w-5 mr-2"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span>{textLoad}...</span>
        </button>
      ) : (
        <button onClick={onClick} className={finalClassName} disabled={isDisabled} {...props}>
          {children}
        </button>
      )}
    </>
  );
};

export default CustomButton;
